import React, {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import Order from "../../API/APIServices/Order";
import { useLocation } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DynamicStaticPage from "./DynamicStaticPage";
import MyContext from "../MyContext";
import ItemMaster from "../../API/APIServices/ItemMaster";

const ThemeModalPortal = forwardRef((props , ref) => {
  const { companyData, imageBaseUrl } = useContext(MyContext);
  const [apiData, setApiData] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [modalHistory, setModalHistory] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const {
    id,
    setShowFirstComponent,
    showFirstComponent,
    lensTypeData,
    lensType,
    eyePower,
    FramePrice,
    AddInCart,
    CodeGen,
    setHeaderName,
    SelectedItem,setLenstype
  } = props;
  // const { item } = location.state || {};

  useEffect(() => {
    console.log("SelectedItem", apiData , SelectedItem);
  }, [SelectedItem , apiData]);

  useEffect(() => {
    ;
    if (lensType != null) {
      setIsDataLoaded(false);
      
      Order.GetChildLensFeaturesByParentId(lensType, 0)
        .then((data) => {
          setLenstype(null);
          
          console.log('data',data);
          setApiData(data);
          setHeaderName(data[0]?.sp6);
          setIsDataLoaded(true);
          setModalHistory((prev) => [
            ...prev,
            { step: 0, data, totalPrice: FramePrice },
          ]);
          // setCurrentStep(1);
        })
        .catch((error) => {
          console.error("Failed to fetch data:", error);
          setIsDataLoaded(true);
          setLenstype(null);
        });
    }
  }, [lensType]);

  const FetchData = async (itemId, newPrice) => {
    setIsDataLoaded(false);
    try {
      ;
      const data = await Order.GetChildLensFeaturesByParentId(0, itemId);
      if (data.length > 0) {
        setApiData(data);
        setHeaderName(data[0].sp6);
        setIsDataLoaded(true);
        setModalHistory((prev) => [
          ...prev,
          { step: currentStep + 1, data, totalPrice: newPrice },
        ]);
        setCurrentStep((prevStep) => prevStep + 1);
      } else {
        setApiData([]);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsDataLoaded(true);
    }
  };

  const handleItemClick = async (dataItem) => {
    var loginDataString = localStorage.getItem("accountLogin");
    var loginData = JSON.parse(loginDataString);
    if (loginData === null) {
      loginData = {
        d1Id: 0,
        d2Id: 0,
      };
    }
    const itemData = await ItemMaster.GetItemMasterById(dataItem.id);
    // const code = CodeGen();
    const newItem = {
      d1ItemId: itemData?.d1_Id || itemData.d1ItemId,
      d2ItemId: itemData?.d2_Id || itemData.d2ItemId,
      d1AccountId: loginData ? loginData.d1Id || 0 : 0,
      d2AccountId: loginData ? loginData.d2Id || 0 : 0,
      userId: 1,
      quantity: 1,
      unit: "Pcs",
      itemPrice: SelectedItem?.salePrice || 0,
      lensPrice: dataItem.sp16,
      lensName: dataItem.sp1, 
      coatingPrice: "",
      coatingName: "",
      thicknessName: "",
      thicknessPrice: "",
      linkedItm: 0,
    };

    setSelectedItems((prevItems) => [...prevItems, newItem]);
  };
  const handleModalClick = (dataitem) => {
    console.log("dataitem.id", dataitem.id);
    const newPrice = calulatePrice(dataitem.iSalePrice);
    FetchData(dataitem.id, newPrice);
    handleItemClick(dataitem);
  };

  const AddCart = () => {
    
    AddInCart(SelectedItem?.d2Id || SelectedItem?.d2_Id, selectedItems);
  };

  const handleBackClick = () => {
    ;
    if (currentStep >= 0) {
      setCurrentStep((prevStep) => prevStep - 1);

      const prevData = modalHistory.find((m) => m.step === currentStep);
      const price = modalHistory.find(
        (m) => m.step === currentStep
      )?.totalPrice;
      if (prevData) {
        setApiData(prevData.data);
        setTotalPrice(price || 0);
        setHeaderName(
          prevData?.data?.[0]?.sp6 != null ? prevData.data[0].sp6 : ""
        );
      }
    } else {
      setApiData([]);
      setModalHistory([]);
      setTotalPrice(FramePrice);
      setCurrentStep(0);
      setShowFirstComponent(true);
    }

    setSelectedItems((prevItems) => {
      if (prevItems.length > 0) {
        const updatedItems = [...prevItems];
        updatedItems.pop();

        return updatedItems;
      }
      return prevItems;
    });
  };

  useImperativeHandle(ref, () => ({
    goBack: handleBackClick,
  }));

  const isNullOrEmpty = (value) =>
    value === null || value === undefined || value === "" || value === "0";

  const calulatePrice = (value) => {
    const updatedTotalPrice = Number(value) + totalPrice;
    setTotalPrice(updatedTotalPrice);
    return updatedTotalPrice;
  };

  useEffect(() => {
    calulatePrice(FramePrice);
  }, [FramePrice]);

  useEffect(() => {
    if (apiData && isDataLoaded && apiData.length == 0) {
      setHeaderName("Eye Power");
    }
  }, [apiData]);

  return showFirstComponent ? null : (
    <>
      {!isDataLoaded ? (
        <div className="buywithlens-content">
          <div className="buywithlens-left">
            <div
              style={{
                overflowX: "hidden",
                overflowY: "scroll",
                height: "75vh",
                scrollbarWidth: "thin",
                padding: "10px",
              }}
            >
              {/* Repeat Skeleton structure */}
              {[...Array(4)].map((_, index) => (
                <div
                  className="buy-with-lens-option-slider-theme3"
                  key={index}
                  style={{
                    padding: "10px",
                    borderRadius: "8px",
                    background: "#f0f0f0",
                    margin: "20px 20px",
                  }}
                >
                  <Skeleton
                    height={60}
                    width={60}
                    style={{ borderRadius: "50%" }}
                  />
                  <div style={{ width: "100%", marginLeft: "10px" }}>
                    <Skeleton height={20} width="80%" />
                    <Skeleton height={15} width="60%" />
                    <Skeleton height={15} width="90%" />
                    <Skeleton height={30} width="50%" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : apiData && apiData.length > 0 ? (
        <div className="buywithlens-content">
          <div className="buywithlens-left">
            <div
              style={{
                overflowX: "hidden",
                overflowY: "scroll",
                height: "75vh",
                scrollbarWidth: "thin",
                padding: "10px",
              }}
            >
              {apiData &&
                apiData
                  .sort((a, b) => {
                    if (a.iDisplayOrder == null || b.iDisplayOrder == null)
                      return 0;
                    return a.iDisplayOrder - b.iDisplayOrder;
                  })
                  .map((dataitem, index) => (
                    <div
                      className="buy-with-lens-option-slider-theme3"
                      onClick={() => handleModalClick(dataitem)}
                      key={index}
                    >
                      {dataitem.childImageId != 0 &&
                        dataitem.childImageId != "" && (
                          <div className="feature-image-coating">
                            <img
                              className="img-coating-features"
                              src={`${imageBaseUrl}${dataitem.childImageId}`}
                              alt=""
                            />
                          </div>
                        )}
                      <div style={{ width: "100%" }}>
                        <p className="Anti-class-add">{dataitem.sp1}</p>
                        <div className="slide-mat-desc">
                          <p
                            style={{ margin: "0", fontSize: "13px" }}
                            // dangerouslySetInnerHTML={{
                            //   __html: dataitem.shortDescription,
                            // }}
                          />
                        </div>
                        <div className="slide-mat-free-gif">
                          <p>{dataitem.freeLens}</p>
                        </div>
                        {isNullOrEmpty(dataitem.sp26) ? (
                          <div className="slide-ofr-sectn-btn">
                            {`Frame+Lens: Get it For ${
                              companyData.currencySymbol
                            }
                      ${(Number(SelectedItem?.salePrice) + Number(dataitem?.iSalePrice || 0)).toFixed(
                        2
                      )}`}
                          </div>
                        ) : (
                          <div className="slide-ofr-sectn-btn">
                            <p
                              style={{
                                margin: "0",
                                fontSize: "13px",
                                display: "inline",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: dataitem.longDescription,
                              }}
                            />
                            {`: ${companyData.currencySymbol}${dataitem.iSalePrice}`}
                          </div>
                        )}
                      </div>
                      <i className="fa-solid fa-chevron-right"></i>
                    </div>
                  ))}
            </div>
            {/* Add in cart Button */}
            <div className="cart-btn-price">
              <div className="slide-head-bar-td-1 flex-subtotal-cart">
                <div className="top-subtotal">
                  <div className="slide-sub-amount-bar">SubTotal (Frame)</div>
                  <div className="slide-sub-amount-bar">
                    {companyData.currencySymbol} {totalPrice}
                  </div>
                </div>
                {/* <div className="cart-button add-cart-top">
                  <div
                    onClick={() => AddCart()}
                    className="slide-head-bar-td-1"
                  >
                    <button className="slide-add-cart-btn">Add To Cart</button>
                  </div>
                </div> */}
              </div>
            </div>
            {/* Add in cart Button */}
          </div>
        </div>
      ) : (
        // If no more child options, show Eye Power Modal
        <div className="buywithlens-content">
          <div className="buywithlens-left">
            <div class="AboutEyePowerContainer">

              <DynamicStaticPage pageName="What About My Eye Power" />
            </div>
            <div className="cart-btn-price">
              <div className="slide-head-bar-td-1 flex-subtotal-cart">
                <div className="top-subtotal">
                  <div className="slide-sub-amount-bar">SubTotal (Frame)</div>
                  <div className="slide-sub-amount-bar">
                    {companyData.currencySymbol}
                    {totalPrice}
                  </div>
                </div>
                <div className="cart-button add-cart-top">
                  <div
                    onClick={() => AddCart(SelectedItem?.d2Id)}
                    className="slide-head-bar-td-1"
                  >
                    <button className="slide-add-cart-btn">Add To Cart</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );


});

export default ThemeModalPortal;
